import { defineStore } from 'pinia';
import {PartySegment} from "@fd/editors/user-select/UserSelectUtils.ts";
import {ref} from "vue";

/** Hold page scoped cache of user/group/parties */
export const usePartyMapStore = defineStore('party-map', () => {
	// Loaded info about party codes
	const partyMap = ref<Record<string | number, PartySegment>>({});

	return { partyMap };
});